// Life Concerns & Guidance discovery hub — responsible, non-guaranteeing language.
export const CONCERNS = [
  {
    id: "love-relationship",
    icon: "HeartHandshake",
    serviceId: "love-separation",
    title_en: "Love & Relationship Difficulties",
    title_bn: "প্রেম ও সম্পর্কের সমস্যা",
    title_hi: "प्रेम व रिश्ते की कठिनाइयाँ",
  },
  {
    id: "separation",
    icon: "HeartCrack",
    serviceId: "love-separation",
    title_en: "Separation & Emotional Distress",
    title_bn: "বিচ্ছেদ ও মানসিক কষ্ট",
    title_hi: "अलगाव व भावनात्मक पीड़ा",
  },
  {
    id: "marriage",
    icon: "Sparkles",
    serviceId: "marriage-problems",
    title_en: "Marriage-Related Concerns",
    title_bn: "বিবাহ সম্পর্কিত সমস্যা",
    title_hi: "विवाह संबंधी चिंताएँ",
  },
  {
    id: "family-harmony",
    icon: "Home",
    serviceId: "marriage-problems",
    title_en: "Family Harmony",
    title_bn: "পারিবারিক সম্প্রীতি",
    title_hi: "पारिवारिक सामंजस्य",
  },
  {
    id: "finance",
    icon: "Coins",
    serviceId: "career-finance",
    title_en: "Financial Difficulties",
    title_bn: "আর্থিক সমস্যা",
    title_hi: "वित्तीय कठिनाइयाँ",
  },
  {
    id: "career",
    icon: "Briefcase",
    serviceId: "career-finance",
    title_en: "Career & Professional Uncertainty",
    title_bn: "কর্মজীবনের অনিশ্চয়তা",
    title_hi: "करियर व व्यावसायिक अनिश्चितता",
  },
  {
    id: "business",
    icon: "Store",
    serviceId: "career-finance",
    title_en: "Business Concerns",
    title_bn: "ব্যবসায়িক সমস্যা",
    title_hi: "व्यापार संबंधी चिंताएँ",
  },
  {
    id: "education",
    icon: "GraduationCap",
    serviceId: "career-finance",
    title_en: "Education & Study Concerns",
    title_bn: "শিক্ষা ও পড়াশোনা সংক্রান্ত",
    title_hi: "शिक्षा व अध्ययन संबंधी",
  },
  {
    id: "children",
    icon: "Baby",
    serviceId: "childbirth-santan",
    title_en: "Child-Related Prayers",
    title_bn: "সন্তান সম্পর্কিত প্রার্থনা",
    title_hi: "संतान संबंधी प्रार्थना",
  },
  {
    id: "obstacles",
    icon: "Mountain",
    serviceId: "tantra-remedies",
    title_en: "Repeated Obstacles & Difficulties",
    title_bn: "বারবার বাধা ও সমস্যা",
    title_hi: "बार-बार बाधाएँ व कठिनाइयाँ",
  },
  {
    id: "fear-anxiety",
    icon: "CloudRain",
    serviceId: "tantra-remedies",
    title_en: "Fear & Anxiety-Related Concerns",
    title_bn: "ভয় ও উদ্বেগ সংক্রান্ত",
    title_hi: "भय व चिंता संबंधी",
  },
  {
    id: "protection",
    icon: "ShieldCheck",
    serviceId: "enemy-protection",
    title_en: "Personal Protection Concerns",
    title_bn: "ব্যক্তিগত সুরক্ষা",
    title_hi: "व्यक्तिगत रक्षा",
  },
  {
    id: "conflict",
    icon: "Swords",
    serviceId: "enemy-protection",
    title_en: "Conflict & Enemy-Related Concerns",
    title_bn: "সংঘাত ও শত্রু সম্পর্কিত",
    title_hi: "संघर्ष व शत्रु संबंधी",
  },
  {
    id: "negative-influence",
    icon: "Ghost",
    serviceId: "tantra-remedies",
    title_en: "Negative Influence Concerns",
    title_bn: "নেতিবাচক প্রভাব",
    title_hi: "नकारात्मक प्रभाव",
  },
  {
    id: "peace",
    icon: "Leaf",
    serviceId: "tantra-remedies",
    title_en: "Peace & Mental Calm",
    title_bn: "শান্তি ও মানসিক প্রশান্তি",
    title_hi: "शांति व मानसिक शांति",
  },
  {
    id: "spiritual-growth",
    icon: "Sprout",
    serviceId: "tantra-remedies",
    title_en: "Spiritual Growth",
    title_bn: "আধ্যাত্মিক উন্নতি",
    title_hi: "आध्यात्मिक विकास",
  },
];

// Responsible guidance note shown on the hub (localized).
export const CONCERN_NOTE = {
  en: "People may seek spiritual guidance or traditional religious practices regarding these concerns. Traditional beliefs may interpret them in different ways, and guidance can help you understand available spiritual or devotional options. For health, fertility, mental-health or legal/financial matters, spiritual services do not replace qualified professionals.",
  bn: "মানুষ এই সমস্যাগুলির জন্য আধ্যাত্মিক পরামর্শ বা ঐতিহ্যবাহী ধর্মীয় অনুশীলন খুঁজতে পারেন। ঐতিহ্যগত বিশ্বাস এগুলিকে বিভিন্নভাবে ব্যাখ্যা করতে পারে; পরামর্শ আপনাকে উপলব্ধ আধ্যাত্মিক বা ভক্তিমূলক বিকল্পগুলি বুঝতে সাহায্য করতে পারে। স্বাস্থ্য, সন্তান, মানসিক বা আইনি/আর্থিক বিষয়ে আধ্যাত্মিক সেবা যোগ্য পেশাদারের বিকল্প নয়।",
  hi: "लोग इन चिंताओं के लिए आध्यात्मिक मार्गदर्शन या पारंपरिक धार्मिक अभ्यास खोज सकते हैं। पारंपरिक मान्यताएँ इन्हें भिन्न रूप से समझ सकती हैं; मार्गदर्शन आपको उपलब्ध आध्यात्मिक या भक्तिमय विकल्पों को समझने में मदद कर सकता है। स्वास्थ्य, संतान, मानसिक या कानूनी/वित्तीय मामलों में आध्यात्मिक सेवाएँ योग्य पेशेवरों का विकल्प नहीं हैं।",
};
